// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoBox[data-v-8aa0f2f2] {\n  display: flex;\n  align-items: center;\n}\n.infoBox .info[data-v-8aa0f2f2] {\n  display: flex;\n  flex-direction: column;\n}\n.name[data-v-8aa0f2f2] {\n  font-weight: bold;\n  font-size: 18px;\n}", ""]);
// Exports
module.exports = exports;
